module.exports = __webpack_public_path__ + "static/media/tractor_tomato.df0aad46.svg";